/*
 * action types
 */
export const GET_DELIVERY_ENABLED_REQUEST = "GET_DELIVERY_ENABLED_REQUEST";
export const GET_DELIVERY_ENABLED_SUCCESS = "GET_DELIVERY_ENABLED_SUCCESS";
export const GET_DELIVERY_ENABLED_FAILURE = "GET_DELIVERY_ENABLED_FAILURE";
export const GET_COMMON_CONFIG_REQUEST = "GET_COMMON_CONFIG_REQUEST";
export const GET_COMMON_CONFIG_SUCCESS = "GET_COMMON_CONFIG_SUCCESS";
export const GET_COMMON_CONFIG_FAILURE = "GET_COMMON_CONFIG_FAILURE";
export const GET_OCCUPATION_REQUEST = "GET_OCCUPATION_REQUEST";
export const GET_OCCUPATION_SUCCESS = "GET_OCCUPATION_SUCCESS";
export const GET_OCCUPATION_FAILURE = "GET_OCCUPATION_FAILURE";

/*
 * action creators
 */
export const getDeliveryEnabledRequest = () => ({
  type: GET_DELIVERY_ENABLED_REQUEST
});

export const getDeliveryEnabledSuccess = data => ({
  type: GET_DELIVERY_ENABLED_SUCCESS,
  data
});

export const getDeliveryEnabledFailure = () => ({
  type: GET_DELIVERY_ENABLED_FAILURE
});

export const getCommonConfigRequest = () => ({
  type: GET_COMMON_CONFIG_REQUEST
});

export const getCommonConfigSuccess = data => ({
  type: GET_COMMON_CONFIG_SUCCESS,
  data
});

export const getCommonConfigFailure = () => ({
  type: GET_COMMON_CONFIG_FAILURE
});

export const getOccupationRequest = () => ({
  type: GET_OCCUPATION_REQUEST
});

export const getOccupationSuccess = data => ({
  type: GET_OCCUPATION_SUCCESS,
  data
});

export const getOccupationFailure = () => ({
  type: GET_OCCUPATION_FAILURE
});



// WEBPACK FOOTER //
// ./src/actions/common.js